import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import {
    FormControl,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { SelectHomeComponent } from 'app/components/select-home/select-home.component';

@Component({
    selector: 'loan-calculator',
    templateUrl: './loan-calculator.component.html',
    styleUrls: ['./loan-calculator.component.scss'],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [
        CommonModule,
        FormsModule,
        SelectHomeComponent,
        MatFormFieldModule,
        MatInputModule,
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatButtonModule,
        SelectHomeComponent,
        MatDialogModule,
        MatIconModule,
    ],
})
export class LoanCalculatorComponent {
    constructor(
        public dialogRef: MatDialogRef<LoanCalculatorComponent>
    ) {}
    emailFormControl = new FormControl('', [
        Validators.required,
        Validators.email,
    ]);

    selectedRepaymentYearsValue: null | string = null;
    selectedInterestValue: null | string = null;

    selectOptionYears = [
        {
            value: '10',
            label: '10 Years',
        },
        {
            value: '5',
            label: '5 Years',
        },
        {
            value: '2',
            label: '2 Years',
        },
        {
            value: '1',
            label: '1 Years',
        },
    ];

    selectOptionsInterest = [
        {
            value: '5',
            label: '5%',
        },
        {
            value: '10',
            label: '10%',
        },
        {
            value: '15',
            label: '15%',
        },
        {
            value: '20',
            label: '20%',
        },
    ];

    handleSelectionChangeRepaymentYears(value: string) {
        this.selectedRepaymentYearsValue = value;
    }

    handleSelectionChangeInterest(value: string) {
        this.selectedInterestValue = value;
    }
}
